import { PartnerSource } from '../enums';
import { SubscriptionTier } from './Subscription';

// eslint-disable-next-line no-shadow
export enum PartnerStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CLOSED = 'closed',
}

// eslint-disable-next-line no-shadow
export enum PartnerLocaleType {
  ENGLISH = 'en',
  SPANISH = 'es',
}

// eslint-disable-next-line no-shadow
export enum PartnerListCategory {
  ONE = 1,
  TWO = 2,
  THREE = 3,
}

// eslint-disable-next-line no-shadow
export enum RebateType {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
}

// eslint-disable-next-line no-shadow
export enum RebateTierCode {
  SNA = 'sna',
  RCC = 'rcc',
  SRT = 'srt',
  AM = 'am',
  ADV = 'adv',
  CC = 'cc',
}

export interface PartnerProductLineRebateRate {
  id: string;
  productLineId: string;
  rebateTierCode: RebateTierCode;
  keepPercentage: number | null;
  rebatePercentage: number | null;
  keepAmount: number | null;
  rebateAmount: number | null;
}

export type MaxRebateInfo = {
  value: number;
  type: RebateType;
} | null;

export interface PartnerProductLine {
  id: string;
  partnerId: string;
  sourceOriginalProductLineId: number | null;
  productLineName: string;
  rebateType: RebateType;
  active: boolean;
  noInput: boolean;
  rebateRates: PartnerProductLineRebateRate[];
}

export interface PartnerConfigTranslation {
  locale: PartnerLocaleType,
  partnerConfigId: string,
  title: string,
  description: string,
  profileDescription?: string,
  perks: string[],
  profileCategory?: string[],
}

export interface PartnerCategoryTranslation {
  id: string;
  key: string;
  locale: PartnerLocaleType;
  displayName: string;
  createDate: Date;
  updateDate: Date;
  createdBy: string | null;
  updatedBy: string | null;
}

export interface PartnerOptin {
  id: string;
  partnerId: string;
  showOptinButton: boolean;
  showMoreInfoButton: boolean;
  requireAccountNumber: boolean;
  alternateDescription: string | null;
  alternateEmailBody: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  createDate: Date;
  updateDate: Date;
}

export interface PartnerConfig {
  partnerId: string,
  logoUrl: string,
  primarySiteUrl: string,
  isNewPartner: boolean,
  isManufacturer: boolean,
  isProfileEnabled?: boolean,
  isPopularPartner?: boolean,
  tier?: string | null,
  category: PartnerListCategory,
  positionInCategory: number | null,
  supportsExistingAccountFlow: boolean,
  hasExtraExistingAccQuestion: boolean,
  partnerConfigTranslations: PartnerConfigTranslation[],
  categories?: PartnerCategoryTranslation[],
  productLines?: PartnerProductLine[],
  maxRebate?: MaxRebateInfo,
}

export interface Partner {
  id: string,
  code: string,
  name: string,
  status: PartnerStatus,
  source: PartnerSource,
  address: string,
  // The minimum subscription tier a member needs to earn rebates from this partner.
  membershipType: SubscriptionTier,
  sourceOriginalId?: string | null,
  syncVersion?: number | null,
  lastSyncedAt?: Date | null,
  config: PartnerConfig | null;
  optin?: PartnerOptin | null;
  productLines?: PartnerProductLine[];
}
